import React from 'react';
import { useInputContext } from '../context/InputContext';
import SearchIcon from '../icons/Search';

export default function NoResults() {
  const { suggestionQuery } = useInputContext();

  return (
    <div className="flex gap-8 text-blue-6 t-body-sm">
      <span className="leading-6">
        <SearchIcon />
      </span>
      <span>
        No results found for &quot;
        {suggestionQuery.toLowerCase()}&quot;, try a different search
      </span>
    </div>
  );
}
